/**
 * Crea la flecha que se va a utilizar para indicar la mano activa
 * @param {*} scene
 */
export function crearFlechaMano(scene) {
  // flechaMano
  scene.anims.create({
    key: 'flechaManoAnimada',
    frames: scene.anims.generateFrameNumbers('flechaMano', {
      start: 0,
      end: 19,
    }),
    frameRate: 10,
    repeat: -1,
  });

  // Ubicación inicial de la flecha (sobre la mano del jugador 1)
  scene.flechaManoMano1 = scene.add
    .sprite(342, 198, 'flechaMano')
    .setDepth(400)
    .setVisible(false);
  scene.flechaManoMano1.play('flechaManoAnimada');

  // Ubicación para mano 2 de jugador 1 (en caso de split)
  scene.flechaManoMano2 = scene.add
    .sprite(502, 126, 'flechaMano')
    .setDepth(400)
    .setVisible(false);
  scene.flechaManoMano2.play('flechaManoAnimada');
}
